import React from 'react';
import { useEffect, useState, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';

import { Typography, Button, Box, TextField } from '@mui/material';
import { supabase } from '../../../api';
import { PROFILE_TABLE } from '../../../constants/supabase_constants';

const StepSixCompanyLink = (props) => {
  const [loading, setLoading] = useState(true);
  const [companyLink, setCompanyLink] = useState(null);

  let { id } = useParams();

  useEffect(() => {
    getProfile();
    // eslint-disable-next-line
  }, []);

  const getProfile = async () => {
    try {
      setLoading(true);
      let { data, error, status } = await supabase
        .from(PROFILE_TABLE)
        .select(`firstName, companyLink`)
        .eq('id', id)
        .single();

      if (data) {
        setCompanyLink(data.companyLink);
      }

      if (error && status !== 406) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async () => {
    try {
      setLoading(true);

      const updates = {
        id: id,
        companyLink: formik.values.companyLink,
        updated_at: new Date(),
      };

      let { error } = await supabase.from(PROFILE_TABLE).upsert(updates, {
        returning: 'minimal', // Don't return the value after inserting
      });

      if (error) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const validationSchema = yup.object({
    companyLink: yup.string('Enter your company link').required('Company name is required'),
  });

  const formik = useFormik({
    initialValues: {
      companyLink: companyLink,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      updateProfile();
      props.handleNext();
    },
  });

  return (
    <Fragment>
      {loading ? (
        'Loading ...'
      ) : (
        <Fragment>
          <Typography variant='h4' sx={{ mt: '3rem', mb: '1rem', fontWeight: 'bold' }}>
            And, what’s your website URL?
          </Typography>
          <Typography variant='body1' sx={{ mb: '3rem' }}>
            It could be your company’s LinkedIn website too but if you don’t have one, type “don’t have one”
          </Typography>

          <form onSubmit={formik.handleSubmit}>
            <TextField
              fullWidth
              id='companyLink'
              name='companyLink'
              label='Company Link'
              sx={{
                mb: '1.5rem',
              }}
              value={formik.values.companyLink}
              onChange={formik.handleChange}
              error={formik.touched.companyLink && Boolean(formik.errors.companyLink)}
              helperText={formik.touched.companyLink && formik.errors.companyLink}
            />

            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Button color='inherit' disabled={props.activeStep === 0} onClick={props.handleBack} sx={{ mr: 1 }}>
                Back
              </Button>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button type='submit'>Next</Button>
            </Box>
          </form>
        </Fragment>
      )}
    </Fragment>
  );
};

export default StepSixCompanyLink;
